export default "__VITE_ASSET__BYtjn7li__"